"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteTreePropertyDefinitionDialogModule = /** @class */ (function () {
    function DeleteTreePropertyDefinitionDialogModule() {
    }
    return DeleteTreePropertyDefinitionDialogModule;
}());
exports.DeleteTreePropertyDefinitionDialogModule = DeleteTreePropertyDefinitionDialogModule;
